import { select, Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

export function getSettingsHandled$(store: Store<fromRoot.State>): Observable<boolean> {
  return store.pipe(
    select(fromRoot.selectCoreContext),
    map((s) => s.settingsHandled),
    filter((v) => !!v),
    distinctUntilChanged(),
  );
}

export function isCookieConsentGiven$(store: Store<fromRoot.State>): Observable<boolean> {
  return store.pipe(
    select(fromRoot.selectCoreContext),
    map((ctx) => ctx.cookieTrackingConsent != null),
    distinctUntilChanged(),
  );
}

export function getCookieConsentStatus$(store: Store<fromRoot.State>): Observable<boolean | null> {
  return store.pipe(
    select(fromRoot.selectCoreContext),
    map((ctx) => ctx.cookieTrackingConsent),
    distinctUntilChanged(),
  );
}
